import React, { useCallback, useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const handleNavClick = useCallback((e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const targetId = href.replace('#', '');
    setIsMobileMenuOpen(false);
    // Delay scroll to let mobile menu close animation finish
    setTimeout(() => {
      const el = document.getElementById(targetId);
      if (el) {
        el.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    }, 300);
  }, []);
  const navLinks = [{
    name: 'Sobre mí',
    href: '#sobre-mi'
  }, {
    name: 'Servicios',
    href: '#servicios'
  }, {
    name: 'Beneficios',
    href: '#beneficios'
  }, {
    name: 'Testimonios',
    href: '#testimonios'
  }];
  return <nav className={`fixed w-full z-50 transition-all duration-300 ${isScrolled ? 'bg-white/90 backdrop-blur-md shadow-sm py-4' : 'bg-transparent py-6'}`} data-id="element-218">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-219">
        <div className="flex justify-between items-center" data-id="element-220">
          <a href="#" className="block" data-id="element-221">
            <img src="https://cdn.magicpatterns.com/uploads/m9csD2VUZJUC4iunSL1yRw/liftapp.png" alt="Vanii" className="h-14 sm:h-18 md:h-24 w-auto object-contain transition-all duration-300" style={{
            filter: 'invert(42%) sepia(13%) saturate(1458%) hue-rotate(236deg) brightness(91%) contrast(85%)'
          }} data-id="element-222" />
          </a>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center space-x-8" data-id="element-223">
            {navLinks.map(link => <a key={link.name} href={link.href} onClick={e => handleNavClick(e, link.href)} className="text-stone-600 hover:text-violet-600 transition-colors text-sm font-medium" data-id="element-224">
                {link.name}
              </a>)}
            <a href="#servicios" onClick={e => handleNavClick(e, '#servicios')} className="bg-violet-600 text-white px-6 py-2 rounded-full text-sm font-medium hover:bg-violet-700 transition-colors" data-id="element-225">
              Reservar
            </a>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden" data-id="element-226">
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="text-stone-600 hover:text-violet-600" data-id="element-227">
              {isMobileMenuOpen ? <X size={24} data-id="element-228" /> : <Menu size={24} data-id="element-229" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Nav */}
      <AnimatePresence data-id="element-230">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-white border-t border-stone-100 overflow-hidden" data-id="element-231">
            <div className="px-4 pt-2 pb-6 space-y-1 shadow-lg" data-id="element-232">
              {navLinks.map(link => <a key={link.name} href={link.href} onClick={e => handleNavClick(e, link.href)} className="block px-3 py-3 text-base font-medium text-stone-600 hover:text-violet-600 hover:bg-violet-50 rounded-md active:bg-violet-100" data-id="element-233">
                  {link.name}
                </a>)}
              <a href="#servicios" onClick={e => handleNavClick(e, '#servicios')} className="block w-full text-center mt-4 bg-violet-600 text-white px-6 py-3 rounded-full text-base font-medium hover:bg-violet-700 active:bg-violet-800 transition-colors" data-id="element-234">
                Reservar
              </a>
            </div>
          </motion.div>}
      </AnimatePresence>
    </nav>;
}